let obj = {};
obj.guarantPre = [
  // {
  //   key: '1',
  //   value: '1个月'
  // },
  // {
  //     key: '2',
  //     value: "2个月",
  // },
  // {
  //     key: '3',
  //     value: "3个月"
  // },
  // {
  //     key: '4',
  //     value: "4个月",
  // },
  // {
  //     key: '5',
  //     value: "5个月",
  // },
  // {
  //     key: '6',
  //     value: "6个月"
  // },
  // {
  //     key: '7',
  //     value: "7个月"
  // },
  // {
  //     key: '8',
  //     value: "8个月"
  // },
  // {
  //     key: '9',
  //     value: "9个月"
  // },
  // {
  //     key: '10',
  //     value: "10个月"
  // },
  // {
  //     key: '11',
  //     value: "11个月"
  // },
  {
    key: '12',
    value: '12个月'
  }
];
obj.companyIdTypeOptions = [
  {
      value: "04",
      name: "统一社会信用代码",
  },
  {
      value: "01",
      name: "组织机构代码证",
  },
  {
      value: "02",
      name: "营业执照"
  },
  {
      value: "03",
      name: "税务登记证"
  }
];
obj.occupationOptionsLevel = [
  {
    value: '1',
    name: '1类'
  },
  {
    value: '2',
    name: '2类'
  },
  {
      value: '3',
      name: "3类",
  },
  {
      value: '4',
      name: "4类",
  }
];
obj.IdTypeOptions = [
  {
    value: '1',
    name: '身份证'
  },
  {
    value: '2',
    name: '护照'
  }
  // {
  //   value:'99',
  //   name:'其它'
  // },
];
obj.sexOptions = [
  {
    value: 'M',
    name: '男'
  },
  {
    value: 'F',
    name: '女'
  }
];
obj.plansValues = [
  {
    name: '方案一',
    value: 'BABJ1'
  },
  {
    name: '方案二',
    value: 'BABJ2'
  },
  {
    name: '方案三',
    value: 'BABJ3'
  }
];
export default { ...obj };
